export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";

export const REGISTRATION_FAIL = "REGISTRATION_FAIL";
export const REGISTRATION_START = "REGISTRATION_START";
export const REGISTRATION_SUCCESS = "REGISTRATION_SUCCESS";

export const PWD_RESET_SUCCESS = "PWD_RESET_SUCCESS";
export const ACCOUNT_CONFIRMATION_FAIL = "ACCOUNT_CONFIRMATION_FAIL";
export const ACCOUNT_CONFIRMATION_SUCCESS = "ACCOUNT_CONFIRMATION_SUCCESS";

export const LOGOUT = "LOGOUT";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const SET_AUTH_ERROR = "SET_AUTH_ERROR";
export const SET_CURRENTUSER = "SET_CURRENTUSER";

export const UPDATE_ACCOUNT_SUCCESS = "UPDATE_ACCOUNT_SUCCESS";
export const UPDATE_ACCOUNT_FAIL = "UPDATE_ACCOUNT_FAIL";

//PRODUCT
export const GET_PRODUCT = "GET_PRODUCT";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";
export const GET_CATEGORY_PRODUCTS = "GET_CATEGORY_PRODUCTS";

//CART
export const EMPTY_CART = "EMPTY_CART";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const REMOVE_ITEM_FROM_CART = "REMOVE_ITEM_FROM_CART";

//PAGINATION
export const PREV_PAGE = "PREV_PAGE";
export const NEXT_PAGE = "NEXT_PAGE";

//SEARCH
export const SEARCH_PRODUCTS = "SEARCH_PRODUCTS";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";
export const SEARCH_FAIL = "SEARCH_FAIL";